import { defineRouting } from "next-intl/routing";
import { locales, defaultLocale } from "@/config";


export const routing = defineRouting({
  locales,
  defaultLocale,

  /**
   * Configures whether and which prefix is shown for a given locale.
   *
   * Default: "always"
   *
   * [see](https://next-intl.dev/docs/routing#localeprefix)
   *
   * Enum:
   *   - `always`: EN -> /en/team, FR -> /fr/equipe
   *   - `as-needed`: EN -> /team, FR -> /fr/equipe
   */
  localePrefix: "always",

  /**
   * By setting this to `false`, the cookie as well as the `accept-language`
   * header will no longer be used for locale detection.
   *
   * Default: true
   *
   * [see](https://next-intl.dev/docs/routing#locale-detection)
   */
  //localeDetection: true,

  pathnames: {
    "/": {},
      "/faq": {},
      "/customer-service": { fr: "/service-clients" },

    "/retail": {},
      "/retail/faq": {},
      "/retail/customer-service": { fr: "/retail/service-clients" },
      "/retail/become-partner": { fr: "/retail/devenir-partenaire" },

    "/blog": "/blog",
      "/blog/[articleSlug]": {},
      "/blog/tag/[categorySlug]": {},
      "/blog/tag": {},

    "/shipping": {},
    "/about-us": { fr: "/a-propos" },
    "/download": { fr: "/telecharger" },
    "/order-retailers": { fr: "/commande-retailers" },
    "/vat-refund-calculator": { fr: "/calculateur-remboursement-tva" },

    "/privacy-policy": { fr: "/politique-de-confidentialite" },
    "/terms-and-conditions": { fr: "/conditions-utilisation" },
  },
});
